export default {"src":"/_next/static/media/schedule.44015ee3.svg","height":616,"width":747,"blurWidth":0,"blurHeight":0};